import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators, NgForm ,FormBuilder} from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'app/shared/auth/auth.service';
import { ApiService } from 'app/shared/services/api.service';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-add-notification',
  templateUrl: './add-notification.component.html',
  styleUrls: ['./add-notification.component.scss']
})
export class AddNotificationComponent implements OnInit {

    notificationForm: FormGroup;
    usersList=[]
    selectedValue=''
    currentUser:any
    constructor(private formBuilder: FormBuilder,
      public apiService:ApiService,
      public toastr: ToastrService,
      private route:Router,
      public authService:AuthService) { 
        // this.currentUser=authService.currentUser()
        // console.log('current user',this.currentUser)
      }
  
    ngOnInit(): void {
      this.getAllUsers()
      this.notificationForm = this.formBuilder.group({
        title: ['', Validators.required],
        description: ['', Validators.required],
        joiningLink: ['', Validators.required],
        user: ['', Validators.required],
      });
    }
    getAllUsers(){
      this.apiService.getAllUsers(1,100).subscribe((res:any)=>{
         this.usersList=res.data.items
         console.log('all user',res)
      })
    }
    getUserId(event:any){
      console.log('user select',this.selectedValue)
    }
    get rf() {
      return this.notificationForm.controls;
    }
   
    submit(){
        let body={
          title:this.notificationForm.value.title,
          description:this.notificationForm.value.description,
          joiningLink:this.notificationForm.value.joiningLink,
          user:this.selectedValue,
        }
        console.log('before body',body)
        this.apiService.createNotification(body).subscribe((res:any)=>{
          if(res.isSuccess === true){
            console.log('create Notification',res)
            this.route.navigate(['/notifications/notification-list'])
          }
          else {
            this.toastr.error(res.eror)
          }      
        })
    }
    back(){
      this.route.navigate(['/notifications/notification-list'])
    }
  
  }
  